import { LoginModel } from '.';
import { formatMessage } from 'src/api';
import MESSAGES from './../../../app/Pages/Home/Login/Login.messages';

export const loginFormData = (): LoginModel => ({
  email: {
    autocomplete: 'email',
    col: 12,
    defaultValue: undefined,
    disabled: false,
    error: false,
    errorMessage: formatMessage({...MESSAGES.loginErrorEmail}),
    label: formatMessage({...MESSAGES.loginLabelEmail}),
    name: 'email',
    type: 'email',
    placeholder: formatMessage({...MESSAGES.loginPlaceholderEmail}),
    required: true,
    validation: 'isEmail',
    value: '',
  },
  password: {
    autocomplete: 'current-password',
    col: 12,
    defaultValue: undefined,
    disabled: false,
    error: false,
    errorMessage: formatMessage({...MESSAGES.loginErrorPw}),
    label: formatMessage({...MESSAGES.loginLabelPw}),
    name: 'password',
    type: 'password',
    placeholder: formatMessage({...MESSAGES.loginPlaceholderPw}),
    required: true,
    validation: 'isLength',
    value: '',
  },
});
